/**
 * Legacy slug → current class id. Lives in its own module so both the
 * canonical label resolver (`classLabels`) and the enrollment identity
 * registry (`classIdentity`) can share it without a circular import.
 */
export const LEGACY_CLASS_ALIASES: Record<string, string> = {
  "mommy-me-baking": "mommy-me-baking-2",
  "beginners-metal-working": "beginners-metalworking",
};
